import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as AgentListActions from './Agentlist.action';
import { NSAdminService } from '../../Clients/NS/Services/NSAdmin.service';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class AgentListEffects {
  constructor(
    private actions$: Actions,
    private buysellRuleservice: NSAdminbuysellRuleserviceService
  ) {}

  loadAgentList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AgentListActions.loadAgentList),
      mergeMap(() =>
        this.buysellRuleservice.GetAgentist().pipe(
          map((agents) => AgentListActions.loadAgentListSuccess({ agents })),
          catchError((error) =>
            of(AgentListActions.loadAgentListFailure({ error }))
          )
        )
      )
    )
  );
}
